<template>
     
    <!--Navbar-->
    <mdb-navbar class="menu-bar-color" dark>
        <!-- Navbar brand orange darken-3-->
        
        <mdb-navbar-toggler>
        <mdb-navbar-nav>
            
            <mdb-nav-item to="/" active>Home</mdb-nav-item>
            <template v-for="(men, key) in menuItems">
                <!--<mdb-nav-item  href="/about" v-bind:key>{{key}}</mdb-nav-item>-->            
                <!--<mdb-nav-item to="/about">Pricing</mdb-nav-item> -->

                <!-- Dropdown -->
                <mdb-dropdown tag="div" class="nav-item">
                <mdb-dropdown-toggle  v-if="key!='order'" tag="a" navLink color="info-color" slot="toggle" waves-fixed href="/about">{{languageData['d'+key.trim()]}}</mdb-dropdown-toggle>
                <mdb-dropdown-menu >
                    
                    <template v-for="(subitems, keiy) in men">
                        <router-link class="dropdown-item" :to="'/module/'+subitems" :key="keiy">{{languageData['m'+subitems]}}</router-link>
                        <!--<mdb-dropdown-item  v-bind:key><router-link to="/about">{{languageData['m'+subitems]}}</router-link></mdb-dropdown-item>-->
                     </template>                
                </mdb-dropdown-menu>
                </mdb-dropdown>
            </template>
           <!-- <mdb-dropdown tag="li" class="nav-item">
            <mdb-dropdown-toggle tag="a" navLink color="info-color" slot="toggle" waves-fixed>Dropdown</mdb-dropdown-toggle>
            <mdb-dropdown-menu>
                <mdb-dropdown-item href="/about">Action</mdb-dropdown-item>                
            </mdb-dropdown-menu>
            </mdb-dropdown>-->

        </mdb-navbar-nav>
        <!-- Search form 
        <form class="form-inline">
            <input class="form-control mr-auto p-2" type="text" placeholder="Search" aria-label="Search">
        </form>-->
        </mdb-navbar-toggler>
    </mdb-navbar>



</template>

<script>
 import { mdbNavbar, mdbNavbarBrand, mdbNavbarToggler, mdbNavbarNav, mdbNavItem, mdbDropdown, mdbDropdownMenu, mdbDropdownToggle, mdbDropdownItem } from 'mdbvue';
    export default{
        name:'MainMenu',

        computed:{  
            menuItems(){           
                //console.log(this.$store.state.menuVar);
                return this.$store.state.menuVar;
                },
            languageData() {return this.$store.state.languageData;}      
        },    

        components: {
            mdbNavbar,
            mdbNavbarBrand,
            mdbNavbarToggler,
            mdbNavbarNav,
            mdbNavItem,
            mdbDropdown,
            mdbDropdownMenu,
            mdbDropdownToggle,
            mdbDropdownItem
        },  
          
        mounted:function(){
            this.showMenu()
        },
        methods: {        
            showMenu(){
                this.$store.dispatch('getMenu');
                //console.log('homeContent'+state.content);
            }
        }
    }; 
</script>

<style scoped>
/*.dropdown:hover>.dropdown-menu {
  display: block;
}
div.dropdown:hover > .dropdown-menu {
    display: block;
}
.dropdown>.dropdown-toggle:active {
  //Without this, clicking will make it sticky
    pointer-events: none;
}
*/

.dropdown-menu li:hover  {
    display: block;
}
.dropdown-menu {
    position:relative;
}


/* rotate caret on hover */
.dropdown-menu > li > a:hover:after {
    text-decoration: underline;
    transform: rotate(-90deg);
} 
.menu-bar-color{
    background-image: linear-gradient(#ffffff -40%, #222a35c7 );
}


</style>
